<script>

export default {
  data() {
    return {
      name: '开通应用',
      tenantList: [],
      platformList: [],
      appList: [],
      data: [],
      state: [
        {
          value: 'tenant',
          label: '企业'
        },
        {
          value: 'platform',
          label: '场站'
        }
      ],
      tenantId: -1,
      platformId: -1,
      loading: false,
      name: ''
    }
  },
  mounted() {
    this.tenantId = 906
    this.platformId = 5
    this.state = 'tenant'
    this.name = ''
    this.getTenantList()
    this.getPlatformList()
    this.getAppList()
    this.$validate.ToDocumentTitle()
  },
  methods: {
    getTenantList() {
      this.$axios.get('/account/tenant/all').then(res => {
        this.tenantList = res.data.data
      }).catch(() => {
        this.tenantList = []
      })
    },
    getPlatformList() {
      this.$axios.get('/account/platform/all').then(res => {
        this.platformList = res.data.data
      }).catch(() => {
        this.platformList = []
      })
    },
    handleChangeState() {
      this.name = ''
      this.tenantId = this.state !== 'tenant' ? 906 : this.tenantId
      this.platformId = this.state !== 'platform' ? 5 : this.platformId
      this.getAppList()
    },
    getAppList() {
      const params = {
        conditions: this.name ? [{ field: 'name', operator: 'like', value1: this.name }] : [],
        sorts: [],
        pageNum: 1,
        pageSize: 2000
      }
      this.$set(this, 'loading', true)
      this.$axios.post('/paas/app/list', params).then((res) => {
        this.$axios.post(`/paas/app/appInstalledWithExpiration?tenantId=${this.tenantId}&platformId=${this.platformId}`).then((appRes) => {
          this.appList = res.data.data.list
          const installedList = appRes.data.data
          for (let i = 0; i < this.appList.length; i++) {
            let item = this.appList[i]
            for (let c = 0; c < installedList.length; c++) {
              let installed = installedList[c]
              if (item.code === installed.code) {
                item['isInstall'] = true
                item['expirationTime'] = installed.expirationTime
              }
            }
          }
          this.getData()
          this.$set(this, 'loading', false)
        }).catch(() => {
          this.data = []
          this.$set(this, 'loading', false)
        })
      }).catch(() => {
        this.data = []
        this.$set(this, 'loading', false)
      })
    },
    getData() {
      if (this.state === 'platform') {
        this.data = this.appList.filter((item) => {
          return item.is_platform
        })
      } else {
        this.data = this.appList.filter((item) => {
          return !item.is_platform
        })
      }
    },
    setInstalled(item) {
      this.$axios.post(`/paas/app/install/${item.id}?tenantId=${this.tenantId}&platformId=${this.platformId}`).then(() => {
        this.$message.success({
          showClose: true,
          message: `开通 ${item.name} 成功`
        })
        this.getAppList()
      }).catch(() => {
      })
    },
    setUnInstalled(item) {
      this.$confirm(`确定关闭该 ${item.name} 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$axios.post(`/paas/app/uninstall/${item.id}?tenantId=${this.tenantId}&platformId=${this.platformId}`).then(() => {
          this.$message.success({ showClose: true, message: `关闭 ${item.name} 成功` })
          this.getAppList()
        }).catch(() => { })
      }).catch(() => { })
    }
  }
}
</script>

<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="padding:10px;">
      <div class="fl" style="display: flex;">
        <el-radio-group @change="handleChangeState()" size="mini" v-model="state">
          <el-radio-button label="tenant">企业</el-radio-button>
          <el-radio-button label="platform">场站</el-radio-button>
        </el-radio-group>
        <el-select placeholder="请选择企业" v-model="tenantId" filterable style="margin-left: 10px"
          @change="handleChangeState()" size="mini" v-if="state === 'tenant'">
          <el-option v-for="item in tenantList" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
        <el-select placeholder="请选择场站" v-model="platformId" filterable style="margin-left: 10px"
          @change="handleChangeState()" size="mini" v-if="state === 'platform'">
          <el-option v-for="item in platformList" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
        <el-input v-model="name" placeholder="请输入应用名称" size="mini" clearable @change="getAppList()"
          style="width: 200px; margin-left: 10px;"></el-input>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="getAppList()" circle icon="el-icon-search"></el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="90%" highlight-current-row
      v-loading="loading">
      <template slot="empty">
        <el-empty></el-empty>
      </template>
      <el-table-column label="行号" type="index" width="50" align="center" />
      <el-table-column prop="name" label="应用名称" width="150" show-overflow-tooltip align="center"></el-table-column>
      <el-table-column prop="code" label="应用编码" width="200" show-overflow-tooltip align="center"></el-table-column>
      <el-table-column prop="remark" label="简介" min-width="180" show-overflow-tooltip align="center"></el-table-column>
      <el-table-column prop="is_platform" label="应用类型" width="100" show-overflow-tooltip align="center">
        <template v-slot="scope">
          <el-tag :type="scope.row.is_platform ? 'primary' : 'success'" size="mini">
            {{ scope.row.is_platform ? '场站' : '企业' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="100" label="操作" align="center">
        <template v-slot="scope">
          <el-button size="mini" @click.native="setInstalled(scope.row)" type="primary" v-if="!scope.row.isInstall">
            开通
          </el-button>
          <el-button size="mini" @click.native="setUnInstalled(scope.row)" type="danger" v-if="scope.row.isInstall">
            关闭
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style scoped></style>